import React from "react";
import { Calendar, Home, Target, UserRound } from "lucide-react";

const BENEFITS = [
  {
    icon: Target,
    title: "Personalized Practice",
    text: "Yoga sessions designed around your individual needs.",
  },
  {
    icon: UserRound,
    title: "One-to-One Guidance",
    text: "Direct attention and corrections from your teacher.",
  },
  {
    icon: Calendar,
    title: "Flexible Schedule",
    text: "Choose a schedule that works in your timezone.",
  },
  {
    icon: Home,
    title: "Learn From Anywhere",
    text: "Practice from the comfort of your home.",
  },
];

export default function PrivateYogaSection({ onFindPrivateTeacher }) {
  return (
    <section className="scroll-mt-28 bg-white" aria-labelledby="private-yoga-heading">
      <div className="container mx-auto px-4 py-16 md:py-20">
        <div className="mx-auto max-w-3xl text-center">
          <h2
            id="private-yoga-heading"
            className="text-3xl font-black tracking-tight text-gray-900 md:text-4xl"
          >
            Personalized 1-to-1 Yoga Sessions
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-gray-600">
            Get personal guidance from an experienced yoga teacher based on your goals, experience and
            schedule.
          </p>
        </div>

        <ul className="mx-auto mt-12 grid max-w-5xl gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {BENEFITS.map(({ icon: Icon, title, text }) => (
            <li key={title} className="text-center sm:text-left">
              <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-xl bg-emerald-50 text-emerald-700 sm:mx-0">
                <Icon size={20} strokeWidth={1.75} />
              </span>
              <h3 className="mt-4 text-base font-bold text-gray-900">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-gray-600">{text}</p>
            </li>
          ))}
        </ul>

        <div className="mt-10 flex justify-center">
          <button
            type="button"
            onClick={onFindPrivateTeacher}
            className="inline-flex items-center justify-center rounded-lg bg-emerald-600 px-6 py-3.5 text-sm font-semibold text-white shadow-sm shadow-emerald-200 transition-colors hover:bg-emerald-700"
          >
            Find a Private Yoga Teacher
          </button>
        </div>
      </div>
    </section>
  );
}
